<template lang="html">
<div class="nav">
    <div class="logo">
      <!-- <img src="../assets/img/logo_2.png"> -->
      <h3><a href="/home">Benchmark</a></h3>
    </div>
    <div class="actions grid" v-if="profile.local.admin == 1">
      <a href="/houses">Benchmark</a>
      <a href="/ratios">Kennzahlen</a>
      <a href="/compare">Kennzahlen vergleichen</a>
      <!-- <a href="#">Reports</a> -->
    </div>
    <div class="footer">
      <p>{{profile.local.email}}<a href="/logout"> <span class="fa fa-power-off"></span></a></p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'hotels'],
  data: function () {
    return {
      profile: JSON.parse(localStorage.profile)
    }
  }
}
</script>

<style lang="css">
    .test {
        color: pink;
        font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue